import React, { Fragment } from 'react';
import { Container } from '@mui/material';
//
import TransactionHistoryTable from './TransactionHistoryTable';
import { useGetPublishersDropdownQuery } from '../../../store/api/publisher.api';

const GatewayTransactions = () => {
  // hooks
  const { data: ugwPublisherOptions = [] } = useGetPublishersDropdownQuery();

  return (
    <Fragment>
      <Container maxWidth='100%'>
        <TransactionHistoryTable clientOptionsData={ugwPublisherOptions} />
      </Container>
    </Fragment>
  );
};
export default GatewayTransactions;
